<template>
    <v-app>    
        <v-main>
            <v-container class="fill-height container-background" fluid></v-container>
            <v-container 
                class="fill-height justify-center" 
                fluid

            >
                <v-row 
                    align="center" 
                    justify="center" 
                    style="z-index:10"
                    class="my-auto"
                >
                    <v-col sm="8" md="6">
                        <v-card class="elevation-12">
                            
                                    <v-row no-gutters>
                                         <v-col cols="12" md="5" class="secondary d-flex pt-4 flex-column justify-center align-center">
                                            
                                            <v-img
                                                src="../../assets/logo.png"
                                                max-width="120"
                                                contain
                                                class="d-flex"
                                            ></v-img>                                            
                                            
                                            <v-card-text class="white--text mt-4">
                                                <div class="primary--text text-h5 text-center font-weight-light mb-3">Welcome to </div>
                                                <div class="primary--text text-h4 text-sm-h5 text-center">{{ schoolName }}</div>
                                                <div class="primary--text text-center mt-3 font-weight-light"> Enter your credentials to sign in</div>
                                            </v-card-text>
                                            
                                        </v-col>
                                        <v-col cols="12" md="7">
                                            <v-window v-model="step">
                                                <v-window-item :value="1"> 
                                            
                                                    <div class="pa-4">
                                                        <v-alert                                                    
                                                            type="error"
                                                            outlined                                                    
                                                            v-if="getloginErrors"
                                                            class="red--text"
                                                        >
                                                            {{ getloginErrors }}
                                                        </v-alert>    
                                                    </div>

                                                    <v-card-text>
                                                        <div class="primary--text text-h5 text-left">Student Portal</div>                                            
                                                    </v-card-text>

                                                    <v-form 
                                                        class="pa-5"
                                                        @submit.prevent
                                                    >
                                                        <v-text-field
                                                            label="Student ID"
                                                            placeholder="Enter student ID"
                                                            name="id"                                                
                                                            type="text"
                                                            color="primary"
                                                            v-model="formData.student_id"
                                                            clearable
                                                            autofocus
                                                            v-on:keyup="nextStep"
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                color="primary"
                                                            >
                                                                mdi-account
                                                            </v-icon>
                                                        </v-text-field>                                                
                                            
                                                        <div class="text-right mt-1 mb-4">                                                
                                                            <v-btn color="primary" @click="submitStudentID" dark>NEXT</v-btn>
                                                        </div>
                                                    </v-form>

                                                    <div>
                                                        <v-btn
                                                            v-if="studentIdQuery"
                                                            text
                                                            color="primary"
                                                            class="text-caption mt-5"
                                                            @click="openDialog(true)"
                                                        >
                                                            Click here to get your student ID
                                                        </v-btn>
                                                    </div>
                                        
                                                </v-window-item>

                                                <v-window-item :value="2">

                                                    <div class="pa-4">
                                                        <v-alert                                                    
                                                            type="error"
                                                            outlined                                                    
                                                            v-if="getloginErrors"
                                                            class="red--text"
                                                        >
                                                            {{ getloginErrors }}
                                                        </v-alert>    
                                                    </div>

                                                    <v-card-text>
                                                        <div class="primary--text text-h5 text-left">Enter Password</div>                                            
                                                    </v-card-text>                                            

                                                    <v-form 
                                                        class="pa-5"
                                                        @submit.prevent="submit"
                                                    >
                                                        <v-text-field
                                                            v-show="password"
                                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                            :type="show ? 'text' : 'password'"
                                                            :label="passwordLabel"
                                                            :placeholder="passwordPlaceholder"
                                                            :hint="passwordHint"
                                                            persistent-hint
                                                            @click:append="show = !show"                                                    
                                                            name="password"
                                                            v-model="formData.password"
                                                            clearable
                                                            autofocus
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                color="primary"
                                                            >
                                                                mdi-key
                                                            </v-icon>
                                                        </v-text-field>
                                                    
                                                
                                                        <div class="text-right mt-1  mb-4">                                                
                                                            <v-btn color="primary" @click="submit" dark>LOGIN</v-btn>
                                                        </div>
                                                    </v-form>

                                                </v-window-item>

                                                <v-window-item :value="3">

                                                    <div class="pa-4">
                                                        <v-alert                                                    
                                                            type="error"
                                                            outlined                                                    
                                                            v-if="resetPasswordErrors"
                                                            class="red--text"
                                                        >
                                                           
                                                        </v-alert>    
                                                    </div>

                                                    <v-card-text>
                                                        <div class="primary--text text-h5 text-left">Reset Password</div>                                            
                                                    </v-card-text>                                            

                                                    <v-form 
                                                        class="pa-5"
                                                        @submit.prevent
                                                    >
                                                        <v-text-field                                                            
                                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                            :type="show ? 'text' : 'password'"
                                                            label="New Password"                                                            
                                                            @click:append="show = !show"                                                    
                                                            name="new-password"
                                                            v-model="formData.newPassword"                                                            
                                                            autofocus
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                color="primary"
                                                            >
                                                                mdi-key
                                                            </v-icon>
                                                        </v-text-field>

                                                        <v-text-field                                                            
                                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                            :type="show ? 'text' : 'password'"
                                                            label="Confirm Password"                                                            
                                                            @click:append="show = !show"                                                    
                                                            name="confirm-password"
                                                            v-model="formData.confirmPassword"                                                                                                                       
                                                        >
                                                            <v-icon
                                                                slot="prepend"
                                                                color="primary"
                                                            >
                                                                mdi-key
                                                            </v-icon>
                                                        </v-text-field>
                                                    
                                                
                                                        <div class="text-right mt-3 mb-4">                                                
                                                            <v-btn color="primary" @click="resetPassword" dark>CHANGE PASSWORD</v-btn>
                                                        </div>
                                                    </v-form>

                                                </v-window-item>

                                            </v-window>                                            
                                        </v-col>
                                
                                    </v-row>                               
                                
                           
                        </v-card>
                    </v-col>
                </v-row>
                <v-overlay
                    :value="getOverlay"
                    opacity="0.8"
                    z-index="10"                    
                >
                    
                    <v-progress-circular
                        indeterminate
                        size="64"
                    ></v-progress-circular>                   
                </v-overlay>
                <query-id/>
            </v-container>            
        </v-main>
        
    </v-app>
</template>

<script>
import QueryId from '../QueryId'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Login',
    components: {
        QueryId,
    },
    data(){
        return {
            step: 1,
            show: false,
            userpassword: '',
            formData: {
                student_id: '',
                password: '',
                newPassword: '',
                confirmPassword: '',
                changedPassword: '',
            },
            password: true,
            studentIdQuery: false,
            passwordPlaceholder: 'Enter date of birth',
            passwordLabel: 'Password',
            passwordHint: 'yyyymmdd',
            windowTitle: 'Enter Password',
            resetPasswordErrors: '',                      
        }
    },         
    props: {
        source: String,
    },
    watch: {
        userpassword: {
            handler(val){
                this.formData.student_id = val;                
            }
        },              
    },
    computed: {
        ...mapGetters({
            getOverlay: 'auth/getOverlay',
            schoolName: 'form/getSchoolName',            
            getloginErrors: 'auth/getLoginErrors',
            getAuthenticated: 'auth/getAuthenticated',
            getResetPassword: 'auth/getResetPassword',
            validStudentID: 'auth/getStudentIDValidation',            
        }),       
        
    },
    methods: {
        ...mapActions({
            signIn: 'auth/signIn',
            changePassword: 'auth/changePassword',
            changeResetPassword: 'auth/changeResetPassword',
            user: 'auth/user',
        }),
        ...mapMutations({
            openDialog: 'auth/setDialog',
            setNewPassword: 'auth/setNewPassword',
            setUserId: 'auth/setUserId',
        }),
        nextStep(e){
            if(e.keyCode === 13){
                console.log('Enter was pressed');
                this.submitStudentID();
            }
        },
        async submitStudentID(){            
            this.setUserId(this.formData.student_id);            
            await this.user();
            if(!this.getResetPassword){
                this.passwordLabel = 'Password';
                this.passwordPlaceholder = '';
                this.passwordHint = '';
            }
            if(this.validStudentID){
                this.step++;
            }            
            
        },
        async submit () {           
            //step++
            //this.step--;
                    
            await this.signIn(this.formData);

            
            if(this.getResetPassword && this.getAuthenticated){
                this.step = 3;
            }
            else if(this.getAuthenticated){
                this.$router.replace('/term-report');
            }
            else{
                this.loginErrors = this.getLoginErrors 
            }
            
                                   
        },
        async resetPassword(){
            console.log("Changing password...");
            //console.log(`Confirm Password: ${this.formData.confirmPassword}`);
            console.log(`New Password: ${this.formData.newPassword}`)
            if(this.formData.newPassword === this.formData.confirmPassword){
                //console.log(`Confirm Password: ${this.formData.confirmPassword}`)
                this.setNewPassword(this.formData.confirmPassword);

                let response = await this.changePassword();
                if(response.status == 200){
                    console.log("password changed successfully");
                    await this.changeResetPassword(0);
                    this.$router.replace('/term-report');
                }
            }
            
        }
        
    }
}
</script>

<style scoped>
    .container-background{
        background-image: url('../../assets/background.jpg');
        background-position: center center;
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-size: cover;
        filter: brightness(40%);
        position: absolute;
    }    

</style>